import React from "react";
import { Container, Item, Menu, Move, Move1, Title } from "./Header.Elements";
import { Link } from "react-router-dom";
import "./header.css";

const Header = ({ view }) => {
  return (
    <Container>
      <Title>
        <Link style={{ textDecoration: "none", color: "inherit" }} to='/'>
          SUMAIL
        </Link>
      </Title>
      <Menu>
        {view === "portfolio" ? (
          <>
            <Item>
              <Move className='link' href='#projects'>
                Projects
              </Move>
            </Item>
            <Item>
              <Move className='link' href='#articles'>
                Articles
              </Move>
            </Item>
            <Item>
              <Move className='link' href='#contact'>
                Contact
              </Move>
            </Item>
          </>
        ) : (
          <>
            <Item>
              <Move1 className='link'>
                <Link
                  style={{ textDecoration: "none", color: "inherit" }}
                  to='/portfolio'
                >
                  Portfolio
                </Link>
              </Move1>
            </Item>
            <Item>
              <Move1 className='link'>
                <Link
                  style={{ textDecoration: "none", color: "inherit" }}
                  to='/'
                >
                  Blogs
                </Link>
              </Move1>
            </Item>
            <Item>
              <Move1 className='link'>
                <Link
                  style={{ textDecoration: "none", color: "inherit" }}
                  to='/contact'
                >
                  Contact
                </Link>
              </Move1>
            </Item>
          </>
        )}
      </Menu>
    </Container>
  );
};

export default Header;
